import toPath from 'lodash/toPath';

const setInWithPath = (state, value, path, pathIndex) => {
  if (pathIndex >= path.length) {
    return value;
  }
  const first = path[pathIndex];
  const firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
  const next = setInWithPath(firstState, value, path, pathIndex + 1);

  const start = parseInt(first, 10);

  if (!state) {
    if (isNaN(first)) {
      return { [first]: next };
    }
    const initialized = [];
    initialized[start] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    const copy = [].concat(state);
    if (next == null) {
      copy.splice(start, 1);
    } else {
      copy[start] = next;
    }

    return copy;
  }

  return {
    ...state,
    [first]: next,
  };
};

const setIn = (state, field, value) => setInWithPath(state, value, toPath(field), 0);

export default setIn;
